export const slug="jood"